<template>
  <div class="section">
    <div class="container">
      <GetSurvey v-model="survey" />
      <SurveyPermissions :survey="survey">
        <div class="">
          <SurveyAdminQuestions :survey="survey" />
        </div>
      </SurveyPermissions>
    </div>
  </div>
</template>

<script>
import SurveyAdminQuestions from "@/components/survey/SurveyAdminQuestions";
import GetSurvey from "@/components/survey/GetSurvey";
import SurveyPermissions from "@/components/survey/SurveyPermissions";

export default {
  name: "SurveyAdmin",
  components: {
    SurveyAdminQuestions,
    GetSurvey,
    SurveyPermissions,
  },
  data() {
    return {
      survey: {},
    };
  },
  computed: {},
};
</script>

<style></style>
